import React from 'react';
import { FormattedMessage } from 'react-intl';

import { routes } from '@/config';

import { MAX_ALERT_COUNT } from '../../constants';
import { useEditAlertMode } from '../../hooks';

import * as S from './search-alert-banner.styles';

type Props = {
  isMobile: boolean;
  isLoggedIn: boolean;
  isAlertActive: boolean;
  isMaximumReached: boolean;
  location?: string;
  keywords?: string;
};

export const SearchAlertBannerText: React.VFC<Props> = ({
  isMobile,
  isLoggedIn,
  isAlertActive,
  isMaximumReached,
  location,
  keywords,
}) => {
  const { isEditingSearchAlert } = useEditAlertMode();

  if (!isLoggedIn) {
    return (
      <>
        <b>
          <FormattedMessage id="SE_AGENTS_JOBS_ALERT_SUBSCRIPTION_MODULE_TITLE" />{' '}
        </b>
        {isMobile ? null : (
          <>
            <FormattedMessage id="SE_AGENTS_JOBS_ALERT_SUBSCRIPTION_MODULE_BODY" />{' '}
            <b>
              {keywords && location ? (
                <FormattedMessage id="SE_JOBS_SUGGESTED_NAME_KEYWORDS_LOCATION" values={{ keywords, location }} />
              ) : location ? (
                <FormattedMessage id="SE_JOBS_SUGGESTED_NAME_LOCATION" values={{ location }} />
              ) : (
                keywords
              )}
            </b>
          </>
        )}
      </>
    );
  }

  if (isMaximumReached) {
    return (
      <FormattedMessage
        id="JOBS_SEARCH_BANNER_ALERTS_MAX_REACHED"
        values={{
          number: MAX_ALERT_COUNT,
          a: (chunks) => <S.AlertsAnchor to={routes.visionTypeAlerts}>{chunks}</S.AlertsAnchor>,
        }}
      />
    );
  }

  if (isMobile) {
    const copy = isAlertActive
      ? 'JOBS_SEARCH_ALERT_BUTTON_CREATED'
      : isEditingSearchAlert
      ? 'JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT'
      : 'JOBS_SEARCH_ALERT_BUTTON_CREATE';
    return <FormattedMessage id={copy} />;
  }

  if (keywords && location) {
    const copy = isAlertActive
      ? 'JOBS_SEARCH_BANNER_ALERTS_ACTIVE_KEYWORDS_CITY'
      : isEditingSearchAlert
      ? 'JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT_DESKTOP_KEYWORDS_CITY'
      : 'JOBS_SEARCH_BANNER_ALERTS_INACTIVE_KEYWORDS_CITY';
    return (
      <FormattedMessage id={copy} values={{ position: keywords, city: location, b: (chunks) => <b>{chunks}</b> }} />
    );
  }

  if (location) {
    const copy = isAlertActive
      ? 'JOBS_SEARCH_BANNER_ALERTS_ACTIVE_CITY'
      : isEditingSearchAlert
      ? 'JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT_DESKTOP_CITY'
      : 'JOBS_SEARCH_BANNER_ALERTS_INACTIVE_CITY';
    return <FormattedMessage id={copy} values={{ city: location, b: (chunks) => <b>{chunks}</b> }} />;
  }

  const copy = isAlertActive
    ? 'JOBS_SEARCH_BANNER_ALERTS_ACTIVE_KEYWORDS'
    : isEditingSearchAlert
    ? 'JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT_DESKTOP_KEYWORDS'
    : 'JOBS_SEARCH_BANNER_ALERTS_INACTIVE_KEYWORDS';
  return <FormattedMessage id={copy} values={{ position: keywords, b: (chunks) => <b>{chunks}</b> }} />;
};
